import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Icon } from 'components';
import styled from 'styled-components';
import { CenterRowDiv, RowDiv, Text, theme } from 'styles';

export function Header(props) {
  const [now, setNow] = useState(moment());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(moment());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <HeaderWrap>
      <HeaderDiv>
        <IconDiv>
          <Icon name="Clock" />
          <Text $width={76} $type="m18" $color="supportive">
            {now.format('HH:mm:ss')}
          </Text>
        </IconDiv>
        <Line />
        <IconDiv>
          <Icon name="Calendar" />
          <Text $width={90} $type="m18" $color="supportive">
            {now.format('YYYY.MM.DD')}
          </Text>
        </IconDiv>
      </HeaderDiv>
    </HeaderWrap>
  );
}

const HeaderWrap = styled.header`
  width: 100%;
  min-width: 1280px;
  height: 48px;
  padding: 12px 40px;
`;

const HeaderDiv = styled(RowDiv)`
  justify-content: flex-end;
  height: 24px;
  gap: 4px;
  align-items: center;
`;

const Line = styled.span`
  height: 18px;
  width: 1px;
  background-color: ${theme.colors.gray100};
`;

const IconDiv = styled(CenterRowDiv)`
  padding: 0 8px 0 4px;
  gap: 4px;
  height: 100%;
`;
